import { Link } from 'react-router-dom'
import { CircleQuestionMark, Phone } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

const QuickLinksCard = () => {
  return (
    <Card className="border-foreground/15 overflow-hidden rounded-2xl border bg-white">
      <div className="bg-foreground px-5 py-3">
        <h2 className="text-sm font-bold tracking-wider text-white uppercase">
          Quick Links
        </h2>
      </div>
      <CardContent className="px-4 pt-0 pb-5 sm:px-6 sm:pt-0">
        <ul className="space-y-1">
          <li>
            <Link
              to="/faqs"
              className="text-foreground flex min-h-11 items-center gap-2.5 text-sm font-semibold hover:text-[#ff914d] sm:text-base"
            >
              <CircleQuestionMark
                className="size-5 shrink-0 text-[#ff914d]"
                aria-hidden="true"
              />
              FAQs
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="text-foreground flex min-h-11 items-center gap-2.5 text-sm font-semibold hover:text-[#ff914d] sm:text-base"
            >
              <Phone
                className="size-5 shrink-0 text-[#ff914d]"
                aria-hidden="true"
              />
              Contact us
            </Link>
          </li>
        </ul>
      </CardContent>
    </Card>
  )
}

export default QuickLinksCard
